import React from "react";
import PropTypes from "prop-types";
var AccordeonContentMj = function (props) {
    var 
    // @ts-ignore
    children = props.children;
    return React.createElement(React.Fragment, null, children);
};
AccordeonContentMj.defaultProps = { __TYPE: "AccordeonContentMj" };
AccordeonContentMj.propTypes = { __TYPE: PropTypes.string };
export default AccordeonContentMj;
